import React, { useEffect, useState } from "react";

type PaginationDotsProps = {
    totalSlides: number;
    activeCardIdx: number;
    onDotClick: (idx: string | number) => void;
};

const PaginationDots: React.FC<PaginationDotsProps> = ({
    totalSlides,
    activeCardIdx,
    onDotClick,
}) => {

    // const [beginDot, setBeginDot] = useState(0);

    // useEffect(() => {
    //     if (totalSlides > 3) {
    //         setBeginDot(Math.max(0, activeCardIdx - 1));
    //     }
    // }, [activeCardIdx, totalSlides]);

    return (
        <div className="flex justify-center items-center">
            {/* {beginDot > 0 && (
                <button
                    onClick={() => onDotClick(beginDot - 1)}
                    className={`w-1 h-1 mx-[10px] rounded-full bg-black opacity-15`}
                    aria-label="pagination back button"
                />
            )} */}
            {Array.from({ length: Math.min(totalSlides) }).map((_, index) => {
                // const dotIndex = beginDot + index;
                return (
                    <button
                        key={index}
                        onClick={() => onDotClick(index)}
                        className={`w-[6px] h-[6px] mx-[10px] rounded-full ${index === activeCardIdx ? "bg-[#1a73e8] opacity-100" : "bg-black opacity-25"
                            }`}
                        aria-label="pagination button"

                    />
                );
            })}
            {/* {beginDot + 2 < totalSlides - 1 && (
                <button
                    onClick={() => onDotClick(beginDot + 3)}
                    className={`w-1 h-1 mx-[10px] rounded-full bg-black opacity-25`}
                    aria-label="pagination next button"
                />
            )} */}
        </div>
    );
};

export default PaginationDots;